import { all } from 'redux-saga/effects';

import addIndividualWatcher from './add-individual-saga';

export default function* rootSaga(action) {
	yield all([addIndividualWatcher(action)]);
}
